import { buildTestIds } from "application";
import { useState } from "react";
import {
  MenuTypes,
  SidebarMenuRefProps,
} from "typing/types/SidebarMenuRefProps";
import {
  CloseSidebarBox,
  CloseSidebarMenuIcon,
  SidebarContainerOverlay,
  SidebarMenuHeader,
  SidebarMenuMobileContainer,
} from "./styles";
import { UserAuthenticationBox } from "../../AuthContent/UserAuthenticationBox";
import { CategoriesSection } from "./CategoriesSection";

export interface SidebarMenuProps {
  sidebarMenuRef: SidebarMenuRefProps;
  isOpenSidebarMenu: boolean;
  onCloseSidebarMenu: () => void;
}

const SidebarMenuMobile = ({
  sidebarMenuRef,
  isOpenSidebarMenu,
  onCloseSidebarMenu,
}: SidebarMenuProps) => {
  const [categoriesLevel, setCategoriesLevel] =
    useState<MenuTypes>("FirstLevel");

  const handleCloseSideBarMenu = () => {
    document.body.style.overflow = "visible";
  };

  return (
    <>
      <SidebarMenuMobileContainer
        ref={sidebarMenuRef}
        isActiveOverlay={isOpenSidebarMenu}
        {...buildTestIds("sidebar-mobile-container")}
      >
        <SidebarMenuHeader {...buildTestIds("styled-sidebar-menu-mobile")}>
          <UserAuthenticationBox />
          <CloseSidebarBox
            id="CloseSidebarBoxId"
            onClick={() => {
              onCloseSidebarMenu();
              handleCloseSideBarMenu();
            }}
            {...buildTestIds("close-sidebar-mobile")}
          >
            <CloseSidebarMenuIcon
              {...buildTestIds("close-sidebar-menu-icon")}
              onClick={() => {
                onCloseSidebarMenu();
                handleCloseSideBarMenu();
              }}
            />
          </CloseSidebarBox>
        </SidebarMenuHeader>
        <CategoriesSection
          level={categoriesLevel}
          onCloseSidebarMenu={onCloseSidebarMenu}
          setCategoriesLevel={setCategoriesLevel}
        />
      </SidebarMenuMobileContainer>
      <SidebarContainerOverlay
        {...buildTestIds("sidebar-mobile-overlay")}
        id="SidebarContainerOverlayId"
        onClick={onCloseSidebarMenu}
        isActiveOverlay={!isOpenSidebarMenu}
      />
    </>
  );
};

export { SidebarMenuMobile };
